import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import ValidationController from '../../controller/ValidationController';
import FieldDateTime from '../common/FieldDateTime';
import FieldSelect from '../common/FieldSelect';
import FieldTextArea from '../common/FieldTextArea';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import CallAPI from '../../api/CallAPI';
import ApiUiController from '../../controller/ApiUiController';
import CallCustom from "./CallCustom";
import Display from '../../util/Display';
class CallPopup extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).call;
    const user = parseInt(reactLocalStorage.getObject(Const.LoggedInUser).user_id);

    this.call = {
      id: 0, direction: 2, date_time: Util.dateToServerDateTime(new Date()), feedback: 0,
      comment: '', responsible_person: user, complete: 0, end_call: '', next_call: '',
      next_meet: '', model_no: props.model_no, model_id: props.model_id
    };

    this.state = { inValid: {}, inApiCall: false, changed: false, call: { ...this.call } };
    this.fieldOption = {};
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.model_id !== this.state.model_id || props.model_no !== this.state.model_no) {
      this.call = { ...this.call, model_no: props.model_no, model_id: props.model_id };
    }
    if (props.call && props.call.id !== this.state.call.id) {
      this.setState({ ...this.state, call: { ...props.call }, inApiCall: false });
    } else if (!props.call) { this.setState({ ...this.state, call: { ...this.call }, inApiCall: false }); }
  }

  onChange = (field, value) => {
    const call = { ...this.state.call };
    call[field] = value;
    if (field === 'feedback' && value !== 0) {
      call['date_time'] = Util.dateToServerDateTime(new Date());
    }
    //const changed = ConditionalFieldUtil.apply(this.model, this.fieldOption, call, field);
    this.setState({ ...this.state, call: { ...call } });
  };

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.state.call);
    if (inValid === null) {
      this.setState({ ...this.state, inApiCall: true });
      CallAPI.save(this.state.call, this.onSaved, this.onFail);
    } else { this.setState({ ...this.state, inValid: { ...inValid } }); }
  };
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onError = () => this.setState({ ...this.state, inApiCall: false });

  onSaved = res => {
    Util.showNotification('Successful', 'Call saved successfully', 'success');
    this.setState({ ...this.state, call: { ...this.state.call, id: res.id }, inApiCall: false });
    this.props.onHide();
    if (this.props.reload) {
      this.props.reload();
    }
  };

  render() {
    const fields = this.model.fields;
    const inValid = this.state.inValid;
    const call = this.state.call;
    const showNext = call.feedback !== 0;

    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered onExit={() => this.isAPICalled = false} className="w-660">

        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {this.props?.call ? 'Update' : 'Add' } {this.model.model_name} :     {Display.ModelName(this.props.lead || this.props.contact)}
          </Modal.Title>
        </Modal.Header>

        <ApiUiController inApiCall={this.state.inApiCall}>
          <Modal.Body>
            <Form>
              <div className="row">
                <FieldSelect key="direction" id="direction" fieldOption={this.fieldOption}
                  field={fields.direction} value={call.direction}
                  onValueChange={this.onChange} inValid={inValid} />

                <FieldDateTime key="date_time" id="date_time" field={fields.date_time}
                  value={call.date_time} onValueChange={this.onChange} inValid={inValid} />
              </div>
              <div className="row">
                <FieldSelect key="responsible_person" id="responsible_person" fieldOption={this.fieldOption}
                  field={fields.responsible_person} value={call.responsible_person}
                  onValueChange={this.onChange} inValid={inValid} />

                <FieldSelect key="feedback" id="feedback" field={fields.feedback} fieldOption={this.fieldOption}
                  value={call.feedback} onValueChange={this.onChange} inValid={inValid} />
              </div>
              <div className="row">
                <FieldTextArea key="comment" id="comment" field={fields.comment} fieldOption={this.fieldOption}
                  value={call.comment} onValueChange={this.onChange} inValid={inValid} />
              </div>

              <div className="row">
                {showNext &&
                  <FieldDateTime key="next_call" id="next_call" field={fields.next_call}
                    value={call.next_call} onValueChange={this.onChange} inValid={inValid} />
                }
                {showNext &&
                  <FieldDateTime key="next_meet" id="next_meet" field={fields.next_meet}
                    value={call.next_meet} onValueChange={this.onChange} inValid={inValid} />
                }
              </div>

              <CallCustom model={this.model} call={call} onValueChange={this.onChange}
                inValid={this.state.inValid} fieldOption={this.fieldOption} />
            </Form>
          </Modal.Body>
          <Modal.Footer><Button onClick={this.onSave}>Submit</Button></Modal.Footer>
        </ApiUiController>
      </Modal>
    );
  }
}
export default CallPopup;